<template>
  <!-- Breadcrumb -->
  <div class="tw-p-2 tw-bg-white tw-w-full tw-border tw-border-solid tw-flex tw-items-center tw-gap-2">
    <router-link :to="{ name: 'pages.admin.dashboard' }"
      class="tw-text-gray-400 tw-duration-200 hover:tw-text-gray-700 tw-text-xl tw-flex tw-items-center tw-gap-2">
      <icon icon="solar:home-smile-bold-duotone" />
      <span class="tw-text-sm">{{ $t("dashboard.sidebar.dashboard") }}</span>
    </router-link>
    <span class="tw-text-gray-300">/</span>
    <router-link :to="{ name: 'pages.admin.videos' }"
      class="tw-text-gray-400 tw-duration-200 hover:tw-text-gray-700 tw-text-xl tw-flex tw-items-center tw-gap-2">
      <span class="tw-text-sm">{{ $t("dashboard.sidebar.videos", "Videos") }}</span>
    </router-link>
    <span class="tw-text-gray-300">/</span>
    <button disabled class="tw-text-primary-500 tw-text-xl tw-flex tw-items-center tw-gap-2">
      <span class="tw-text-sm">{{ $t("common.create", "Create") }}</span>
    </button>
  </div>

  <div class="tw-p-2">
    <div class="tw-w-full tw-bg-white tw-rounded-lg tw-p-6 tw-border tw-border-solid tw-border-gray-200">
      <div class="tw-mb-8">
        <h1 class="tw-text-2xl tw-font-bold tw-text-gray-900 tw-mb-1">{{ $t('videos.create-title', 'Add a new video') }}</h1>
        <p class="tw-text-sm tw-text-gray-600">{{ $t('videos.create-subtitle', 'Publish a video to the on-demand library') }}</p>
      </div>

      <VideoForm
        ref="formRef"
        :saving="saving"
        :submit-label="$t('videos.create-button', 'Create video')"
        @submit="createVideo"
        @cancel="goBack"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import VideoForm from './partials/VideoForm.vue';
import videosApi from '@/api/videos';
import useAlert from '@/composables/useAlert';

const router = useRouter();
const { t } = useI18n();

const saving = ref(false);
const formRef = ref(null);

const goBack = () => router.push({ name: 'pages.admin.videos' });

const createVideo = async (formData) => {
    saving.value = true;
    try {
        await videosApi.admin.store(formData);
        useAlert(t('videos.created', 'Video created successfully'), 'success');
        router.push({ name: 'pages.admin.videos' });
    } catch (error) {
        console.error('Error creating video:', error);
        if (error.response?.status === 422) {
            formRef.value?.setErrors(error.response.data?.errors || {});
            useAlert(t('videos.fix-errors', 'Please fix the form errors'), 'warning');
        } else {
            useAlert(error.response?.data?.message || t('errors.something-went-wrong', 'Something went wrong'), 'danger');
        }
    } finally {
        saving.value = false;
    }
};
</script>
